'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPageOfMessagesToThreadHistory = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _mergeMessages = require('./mergeMessages');

var _sortMessages = require('./sortMessages');

var _setMinMaxTimestamps = require('./setMinMaxTimestamps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add a new page of messages to a Threadhistory
 *
 * @param {ThreadHistory} newThreadHistory
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var addPageOfMessagesToThreadHistory = exports.addPageOfMessagesToThreadHistory = (0, _curry2.default)(function (newThreadHistory, threadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(newThreadHistory);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);
  return (0, _pipe2.default)((0, _mergeMessages.mergeMessages)(threadHistory.messages), _sortMessages.sortMessages, (0, _setMinMaxTimestamps.setMinMaxTimestamps)(threadHistory))(newThreadHistory);
});